import { HttpError } from './http.error';

export class NoResponseError extends HttpError {}
